module.exports = __webpack_public_path__ + "static/6Sigma_CorredorNorte-b4f302263840543ee157a6c343f8e18c.jpg";